import template from './pageHeader.html';

class PageHeaderController {
    constructor($state) {
        this.$state = $state;
        this.icon = this.icon || false;
    }
}

PageHeaderController.$inject=['$state'];

const PageHeaderComponent = {
    restrict: 'E',
    templateUrl: template,
    controller: PageHeaderController,
    controllerAs: 'vm',
    bindings: {
        icon: '<',
        pageTitle: '<',
        pageDesc: '<'
    }
};

export {PageHeaderComponent};



// WEBPACK FOOTER //
// ./app/components/common/pageHeader/pageHeader.component.js